const hexToLuma = color => {
  const hex = color.replace(/#/, '')
  const r = parseInt(hex.substr(0, 2), 16)
  const g = parseInt(hex.substr(2, 2), 16)
  const b = parseInt(hex.substr(4, 2), 16)

  return [0.299 * r, 0.587 * g, 0.114 * b].reduce((a, b) => a + b) / 255
}
const textColor = color => {
  return hexToLuma(color) > 0.5 ? '#000000' : '#ffffff'
}
const themeByColor = color => {
  return hexToLuma(color) > 0.5 ? 'light' : 'dark'
}
const themeByGradient = function (colorA, colorB) {
  return Math.min(hexToLuma(colorA), hexToLuma(colorB)) > 0.5 ? 'light' : 'dark'
}
const themeByTextColor = color => {
  return hexToLuma(color) > 0.5 ? 'dark' : 'light'
}
const hexToRgb = hexColor => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexColor)
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16),
  } : null
}
const hexToCSSVariable = hexColor => {
  const rgb = hexToRgb(hexColor)
  return `${ rgb.r },${ rgb.g },${ rgb.b }`
}
export { hexToLuma, textColor, themeByColor, themeByTextColor, themeByGradient, hexToRgb, hexToCSSVariable }
